import { Video, Download, Calendar, PlayCircle, Megaphone } from 'lucide-preact';
const META = {
    OnlineEvent: {
        Icon: Video,
        chipClass: 'bg-violet-100 text-violet-800 dark:bg-violet-900/50 dark:text-violet-300'
    },
    Download: {
        Icon: Download,
        chipClass: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/50 dark:text-indigo-300'
    },
    Meeting: {
        Icon: Calendar,
        chipClass: 'bg-teal-100 text-teal-800 dark:bg-teal-900/50 dark:text-teal-300'
    },
    Demo: {
        Icon: PlayCircle,
        chipClass: 'bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-300'
    },
};
const DEFAULT_META = {
    Icon: Megaphone,
    chipClass: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300'
};
export function getWebTypeMeta(type) {
    if (!type)
        return DEFAULT_META;
    const key = type.trim();
    if (key in META)
        return META[key];
    return DEFAULT_META;
}
